import { Avatar, Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../firebase";
const EventSpeakers = ({ eventDocId }) => {
  const [speakers, setSpeakers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSpeakers = async () => {
      try {
        const speakersRef = collection(db, `events/${eventDocId}/speakers`);
        const snapshot = await getDocs(speakersRef);
        const speakersData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setSpeakers(speakersData);
      } catch (error) {
        console.error("Error fetching speakers:", error);
      } finally {
        setLoading(false);
      }
    };
    if (eventDocId) {
      fetchSpeakers();
    }
  }, [eventDocId]);

  if (loading) return <p>Loading speakers...</p>;
  if (speakers.length === 0) return <p>No speakers available for this event.</p>;

  return (
    <Box
      sx={{ p: 3, maxWidth: "1200px", margin: "auto", textAlign: "center", }}  >
      <Typography variant="h3" fontWeight="bold" gutterBottom>
        Our Speakers
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ mt: 2, mb: 4 }}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      </Typography>
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        {speakers.map((speaker) => (
          <Grid size={{ xs: 12, sm: 4, md: 3 }} key={speaker.id} >
            <Card elevation={0} sx={{ bgcolor: "grey.100", display: "flex", alignItems: "center", p: 1, borderRadius: 3, }}>
              <Avatar src={speaker.speakerPicture} alt={speaker.speakerName} sx={{ width: 60, height: 60, }}
              />
              <CardContent>
                <Typography variant="h6">{speaker.speakerName}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {speaker.speakerTitle} @ {speaker.speakerCompany}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EventSpeakers;
